import { laptopMediumMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.background};
  border-top: 1px solid ${({ theme }) => theme.keyline};
  border-bottom: 1px solid ${({ theme }) => theme.keyline};
  width: 100%;
`;

export const Rail = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
`;

export const FadeOver = styled.div`
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  width: 50px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 15px;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  button,
  svg {
    display: block;
    color: ${({ theme }) => theme.textDark};
  }
`;

export const Content = styled.div`
  padding: 10px 40px 10px 15px;
  display: inline-flex;
  gap: 15px;
  flex-wrap: nowrap;

  @media (${laptopMediumMax}) {
    padding: 10px 40px 10px 15px;
  }

  @media (${tabletMax}) {
    gap: 10px;
  }
`;

export const SlideshowBtnStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 30px;
  border: 1px solid ${({ theme }) => theme.keyline};
  color: ${({ theme }) => theme.textDark};
  font-size: 16px;
  font-weight: 600;
  transition: 200ms all;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.background};

  &:hover {
    background-color: ${({ theme }) => theme.backgroundLightest};
  }

  svg {
    width: 18px;
    margin-right: 6px;
    max-height: 18px;
  }

  @media (${tabletMax}) {
    font-size: 12px;
    padding: 10px 16px;
  }
`;

export const Button = styled(Link)<{ $active: boolean }>`
  ${SlideshowBtnStyle}
  ${({ $active }) =>
    $active &&
    css`
      background-color: ${({ theme }) => theme.textDark};
      color: ${({ theme }) => theme.white};
      border: 1px solid ${({ theme }) => theme.textDark};

      &:hover {
        background-color: ${({ theme }) => theme.textDark};
      }
    `}
`;

export const Pill = styled.span`
  background-color: ${({ theme }) => theme.primary};
  border-radius: 4px;
  padding: 2px 5px;
  color: ${({ theme }) => theme.white};
  margin-left: 8px;
  font-size: 11px;
  font-weight: bold;
`;
